module.exports = __webpack_public_path__ + "web/img/verify5.642477df.jpg";